<template>
  <div>
    <!-- Cancel Confirmation -->
    <modal
        v-if="showCancelModal"
        :show="showCancelModal"
        :title="$t('Cancel subscription')"
        save-text="Cancel subscription"
        close-text="Back"
        :loading="loading"
        primary-button-class="error"
        max-width="480"
        hide-top-close-button
        @close="closeCancelModal"
        @save="confirmCancel"
    >
        <v-card-text class="pt-2">
            <p class="body-1 mb-3">
                {{ $t('cancelSubscriptionConfirmModal.title') }}
            </p>
            <v-alert
                type="warning"
                text
                dense
                class="mb-0"
                icon="mdi-information-outline"
            >
                <p
                  v-html="
                    $t('cancelSubscriptionConfirmModal.description', {
                        date: subscriptionToCancelEndsAt
                            ? `(<b>${fullDateFormat(subscriptionToCancelEndsAt)}</b>)`
                            : ''
                    })
                  "
                ></p>
            </v-alert>
        </v-card-text>
    </modal>

    <!-- Subscription Cancelled -->
    <modal
        :show="showCancelConfirmedModal"
        :title="$t('Subscription cancelled')"
        save-text="OK"
        max-width="480"
        hide-top-close-button
        hide-actions-cancel
        @close="showCancelConfirmedModal = false"
        @save="showCancelConfirmedModal = false"
    >
        <v-card-text class="pt-2">
            <v-alert
                type="info"
                text
                dense
                class="mb-0"
                icon="mdi-information-outline"
            >
                <p
                  v-html="
                    $t('cancelSubscriptionConfirmModal.description', {
                        date: subscriptionToCancelEndsAt
                            ? `(<b>${fullDateFormat(subscriptionToCancelEndsAt)}</b>)`
                            : ''
                    })
                  "
                ></p>
            </v-alert>
        </v-card-text>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { fullDateFormat } from '@/components/calendar/config';
import Modal from '@/components/Modal.vue';
import SubscriptionsMixin from '@/lib/SubscriptionsMixin';

export default {
  name: 'CancelSubscription',
  components: { Modal },
  mixins: [SubscriptionsMixin],
  data() {
    return {
      showCancelModal: false,
      showCancelConfirmedModal: false,
      subscription: null,
    };
  },
  computed: {
    ...mapGetters(['loading']),
    subscriptionToCancelEndsAt() {
      if (!this.subscription) {
        return null;
      }
      return this.getSubscriptionEndsAt(this.subscription);
    },
  },
  methods: {
    fullDateFormat,
    open(subscription) {
      this.subscription = subscription;
      this.showCancelModal = true;
    },
    closeCancelModal() {
      this.showCancelModal = false;
      this.subscription = null;
    },
    confirmCancel() {
      if (this.loading) {
        return;
      }

      this.$store.dispatch('loading', true);
      axios
        .post(`/subscriptions/${this.subscription.id}/cancel`)
        .then(() => {
          this.$store.dispatch('loading', false);
          this.$store.dispatch('message', this.$t('Subscription cancelled'));
          this.closeCancelModal();
          this.showCancelConfirmedModal = true;

          this.$emit('cancelled');
        })
        .catch((error) => {
          this.$store.dispatch('loading', false);
          this.closeCancelModal();

          if (error.response && error.response.data && error.response.data.errors) {
            this.$store.dispatch('setErrors', [error.response.data.errors]);
          } else if (error.response && error.response.data && error.response.data.message) {
            this.$store.dispatch('setErrors', [[error.response.data.message]]);
          }
        });
    },
  },
};
</script>
